<template>
  <div class="privacyPolicy">
    <!-- v-if="$route.query.type == 'student'" -->
    <template v-if="$route.query.type == 'student'">
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: center;
        "
      >
        <span style="font-family: '等线'; font-size: 21.33px"
          ><strong>文通云学生端应用隐私政策</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;【特别提示】请仔细阅读《文通云学生端应用隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。<strong
            >阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，文通云学生端将暂时无法为您提供服务。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 13.33px">尊敬的用户:</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;文通云学生端是由成都文通网络科技发展有限公司（以下简称“公司”）运营的在线教育增值服务平台。本隐私政策与您所使用的文通云学生端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。<strong>您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</strong>如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至“ckwool@qq.com&nbsp;”或拨打我们的客服电话“17708004966”与我们联系。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >一、&nbsp;适用范围</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;本隐私政策适用于文通云学生端提供的所有服务，您访问文通云学生端网站、客户端，均适用本隐私政策。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >二、我们收集信息的原因和内容</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >2.1&nbsp;您直接提供给我们的信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;当您注册时，您需要至少向我们提供您准备使用的<strong>文通云学生端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱）</strong>，我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：<strong>帐号名称、头像（如有）和手机号码等</strong>。提供上述信息并同意注册协议和本政策后，您可以使用文通云学生端的部分业务功能。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >在您注册文通云学生端帐号时，我们会使用手机号码对您的学生信息（姓名、学校、学号/学籍号）进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供准确的服务。如您拒绝提供手机号码或进行学生信息绑定，<strong
            >您可能将无法使用文通云学生端内的内容与功能。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 0.07px;
          margin-top: 0px;
          text-align: justify;
          text-indent: -0.07px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >2.2&nbsp;征得授权同意的例外</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据相关法律法规的规定，<strong
            >以下情形中收集您的个人信息无需征得您的授权同意：</strong
          ></span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >（1）涉及国家安全与利益、社会公共利益；</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >（2）与犯罪侦查有关的相关活动；</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >（4）从其他合法公开的渠道中收集您的个人信息；</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >（5）法律法规规定的其他情形。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 0.07px;
          margin-top: 0px;
          text-align: justify;
          text-indent: -0.07px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >三、我们会如何使用您的信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >您的信息主要有以下用途：</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp; &nbsp;为您提供您使用的各项服务，并维护、改进这些服务。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp; &nbsp;帮助我们设计新服务，提升现有服务体验。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 0.07px;
          margin-top: 0px;
          text-align: justify;
          text-indent: -0.07px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >四、我们可能如何收集信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >4.1&nbsp;设备权限调用</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;文通云学生端在提供服务的过程中，可能需要您开通一些设备权限，例如、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝文通云学生端收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp; &nbsp;根据您的服务使用情况，我们可能会调用的权限如下：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 0.07px;
          margin-top: 0px;
          text-align: justify;
          text-indent: -0.07px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（1）储存权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用APP的图片保存功能时，我们会调用您的储存权限，保障您能顺利实现这些功能。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（2）录音权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您选用本产品的录音或连麦时，我们会调用您的麦克风及录音权限，保障您的功能。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（3）摄像头权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用试题或头像拍照上传功能时，我们将调用您的摄像头权限，保障您对头像进行更换。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（4）拨打电话权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您需要联系客服，点击拨打电话时，我们将调用您的拨打电话权限。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（5）相册权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用图片保存的功能时，我们会调用您的相册权限，保障您能顺利实现这些功能。</span
        ><br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >五、我们会如何共享、转让、公开披露您的个人信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >5.1&nbsp;共享</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp; &nbsp;文通云学生端不会将您的个人信息提供给第三方。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;共享给文通云学生端公司内部：在本政策声明的使用目的范围内，您的个人信息可能会与文通云公司内部其他功能共享。作为一项政策，我们只会共享必要的信息。如要改变个人信信息，在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >出于技术需要，平台需嵌入第三方软件开发工具包（SDK）。平台所嵌入的第三方SDK及第三方SDK所需收集或阈值共享的信息如下：</span
        >
      </p>
      <figure
        class="table"
        style="margin-left: auto; margin-right: auto; width: 556.73px"
      >
        <table style="border-collapse: collapse; width: 100%">
          <thead>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >SDK名称</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >涉及的个人信息</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >服务用途</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >SDK相关隐私政策地址</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >所属公司</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >腾讯X5浏览器</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >网络连接状态</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >用于显示附带数学公式的html5试题</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a
                      href="https://x5.tencent.com/tbs/guide/develop.html#5"
                      target="_blank"
                      >https://x5.tencent.com/tbs/guide/develop.html#5</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >深圳市腾讯计算机系统有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟推送SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）、应用列表（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >进行APP消息推送</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟分享SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（IMEI/MAC/Android
                    ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >支持用户在主流应用上分享APP内容</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟应用性能监控SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >提供APP应用性能监控服务</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟移动统计SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）、应用列表（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >进行APP数据统计分析</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >5.2&nbsp;转让</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >5.3&nbsp;公开披露</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;我们仅会在以下情况下，才会公开披露您的个人信息：根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。</span
        ><br />
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >六、&nbsp;如何管理您的个人信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.1&nbsp;除法律法规规定外，您有权随时访问和更正您的个人信息。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.2&nbsp;您可以通过电话（17708004966）或邮箱（ckwool@qq.com）<strong>，并提供注册使用的手机号，向我们提出删除个人信息，我们将在15个工作日内帮您删除个人信息中的某一项或某几项。</strong>如我们停止运营或停止提供相关服务，我们将会及时停止收集您个人信息，并将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.3&nbsp;您可以通过电话（17708004966）或邮箱（ckwool@qq.com），向我们提出撤回对于隐私政策协议内容的同意授权。<strong
            >当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理，我们会在15天内响应、做出答复或合理解释。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 28px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >6.4如需注销账号，您可以通过电话（17708004966）或邮箱（ckwool@qq.com），向我们提出注销账号的需求并说明情况，我们会尽快为您注销账号。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >七、我们会如何保护和保存您的个人信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云学生端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。&nbsp;我们会采取一切合理可行的措施，确保未收集与文通云学生端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的文通云学生端及文通云学生端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与文通云学生端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与文通云学生端的合作关系。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，且存储期限满足法律法规要求的最小期限，超出储存期限后将对您的数据进行匿名化处理。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >八、文通云学生端会如何处理未成年人的个人信息</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用文通云学生端服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >九、&nbsp;本政策如何更新及适用范围</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;为给用户提供更好的服务，文通云学生端的业务将不时变化，本隐私政策也将随之调整。我方会通过在文通云学生端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问文通云学生端以便及时了解最新的隐私政策。我方保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，文通云学生端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。&nbsp;</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >若您不同意修改后的隐私政策，您有权并应立即停止使用文通云学生端的服务。如果您继续使用文通云学生端的服务，则视为您接受文通云学生端对本政策相关条款所做的修改。文通云学生端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明我方在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >十、&nbsp;联系我们</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;如果您有任何个人信息的疑问、意见、建议或投诉举报，您可以通过电话（17708004966）或邮箱（ckwool@qq.com）随时与我们联系&nbsp;，我们将在15日内回复您的请求。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px"
          >十一、更新说明</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;成都文通网络科技发展有限公司保留随时更新本声明的权利，当声明发生修改时，我们会通过通知的方式告知您变更后的声明。如您继续使用我们的服务，即视为您同意我们的变更后的隙私政策我们才会按照更新的声明收集、使用、存储您的个人信息。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp; &nbsp;本声明自更新之日起生效</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;最近的更新日期：2024&nbsp;年&nbsp;3月&nbsp;19&nbsp;日</span
        >
      </p>
    </template>
    <template v-else>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: center;
        "
      >
        <span style="font-family: '等线'; font-size: 21.33px"
          ><strong>文通云教师端应用隐私政策</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >【特别提示】请仔细阅读《文通云教师端应用隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。<strong
            >阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，文通云教师端将暂时无法为您提供服务。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >尊敬的用户：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云教师端是由成都文通网络科技发展有限公式（以下简称“公司”）运营的在线教育增值服务平台。本隐私政策与您所使用的文通云教师端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。<strong>您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</strong>如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至“ckwool@qq.com&nbsp;”或拨打我们的客服电话“17708004966”与我们联系。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >一、 适用范围</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >本隐私政策适用于文通云教师端提供的所有服务，您访问文通云教师端网站、客户端，均适用本隐私政策。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >二、我们收集信息的原因和内容</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >2.1 您直接提供给我们的信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。<strong
            >提供上述信息并同意用户协议和本政策后，您可以使用文通云教师端的部分业务功能。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >2.3 征得授权同意的例外</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >（1）涉及国家安全与利益、社会公共利益；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >（2）与犯罪侦查有关的相关活动；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >（4）从其他合法公开的渠道中收集您的个人信息；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >（5）法律法规规定的其他情形。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >三、我们会如何使用您的信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >您的信息主要有以下用途：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >为您提供您使用的各项服务，并维护、改进这些服务。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >帮助我们设计新服务，提升现有服务体验。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >邀请您参与文通云教师端活动和市场调查</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >四、我们可能如何收集信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >4.1 设备权限调用</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云教师端在提供服务的过程中，可能需要您开通一些设备权限，例如相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝文通云教师端收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据您的服务使用情况，我们可能会调用的权限如下：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 0.07px;
          margin-top: 0px;
          text-align: justify;
          text-indent: -0.07px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（1）储存权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用APP的图片保存功能时，我们会调用您的储存权限，保障您能顺利实现这些功能。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（2）录音权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您选用本产品的录音或连麦时，我们会调用您的麦克风及录音权限，保障您的功能。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（3）摄像头权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用试题或头像拍照上传功能时，我们将调用您的摄像头权限，保障您对头像进行更换。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（4）拨打电话权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您需要联系客服，点击拨打客服电话时，我们将调用您的拨打电话权限。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          ><strong>（5）相册权限</strong></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >当您使用图片保存的功能时，我们会调用您的相册权限，保障您能顺利实现这些功能：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >五、我们会如何共享、转让、公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px">5.1 共享</span>
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云教师端非必要时不会将您的个人信息提供给第三方，如果必须要共享，会事先征得您本人的同意。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云教师端可能会共享您的某些个人信息，以便给您提供服务和建议。例如，我方向您寄送礼品（如有）时，我方必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: Calibri; font-size: 13.33px"
          >出于技术需要，平台需嵌入第三方软件开发工具包（SDK）。平台所嵌入的第三方SDK及第三方SDK所需收集或阈值共享的信息如下：</span
        >
      </p>
      <figure
        class="table"
        style="margin-left: auto; margin-right: auto; width: 556.73px"
      >
        <table style="border-collapse: collapse; width: 100%">
          <thead>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >SDK名称</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >涉及的个人信息</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >服务用途</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >SDK相关隐私政策地址</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >所属公司</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >腾讯X5浏览器</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >网络连接状态</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >用于显示附带数学公式的html5试题</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a
                      href="https://x5.tencent.com/tbs/guide/develop.html#5"
                      target="_blank"
                      >https://x5.tencent.com/tbs/guide/develop.html#5</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >深圳市腾讯计算机系统有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟推送SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）、应用列表（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >进行APP消息推送</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟分享SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（IMEI/MAC/Android
                    ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >支持用户在主流应用上分享APP内容</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟应用性能监控SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >提供APP应用性能监控服务</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      background-color: #ffffff;
                      color: #191919;
                      font-family: '微软雅黑';
                      font-size: 14px;
                    "
                    >友盟移动统计SDK</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.27px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >设备信息（Android
                    ID/IDFA/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、位置信息（可选）、应用列表（可选）</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >进行APP数据统计分析</span
                  >
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px">
                    <a href="https://www.umeng.com/page/policy" target="_blank"
                      >https://www.umeng.com/page/policy</a
                    >
                  </span>
                </p>
              </td>
              <td
                style="
                  border: 1px solid #000000;
                  padding: 0px 7.2px;
                  vertical-align: top;
                  width: 111.4px;
                "
              >
                <p
                  style="
                    line-height: 1.5;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    text-align: center;
                  "
                >
                  <span style="font-family: Calibri; font-size: 13.33px"
                    >友盟同欣（北京）科技有限公司</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px">5.2 转让</span>
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >事先获得您明确地同意或授权；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必需的情况进行提供；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >5.3 公开披露</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >六、如何管理您的个人信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.1&nbsp;除法律法规规定外，您有权随时访问和更正您的个人信息。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.2&nbsp;您可以通过电话（17708004966）或邮箱（ckwool@qq.com）<strong>，并提供注册使用的手机号，向我们提出删除个人信息，我们将在15个工作日内帮您删除个人信息中的某一项或某几项。</strong>如我们停止运营或停止提供相关服务，我们将会及时停止收集您个人信息，并将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;6.3&nbsp;您可以通过电话（17708004966）或邮箱（ckwool@qq.com），向我们提出撤回对于隐私政策协议内容的同意授权。<strong
            >当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理，我们会在15天内响应、做出答复或合理解释。</strong
          ></span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 28px;
        "
      >
        <span style="font-family: Calibri; font-size: 13.33px"
          >6.4如需注销账号，您可以通过电话（17708004966）或邮箱（ckwool@qq.com），向我们提出注销账号的需求并说明情况，我们会尽快为您注销账号。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >七、我们会如何保护和保存您的个人信息</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >文通云教师端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
          我们会采取一切合理可行的措施，确保未收集与文通云教师端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的文通云教师端及文通云教师端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被终止与文通云教师端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被终止与文通云教师端的合作关系。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，且存储期限满足法律法规要求的最小期限，超出储存期限后将对您的数据进行匿名化处理。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >八、本政策如何更新及适用范围</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >为给用户提供更好的服务，文通云教师端的业务将不时变化，本隐私政策也将随之调整。我方会通过在文通云教师端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问文通云教师端以便及时了解最新的隐私政策。我方保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，文通云教师端会通过不同渠道向您发送变更通知，包括但不限于弹窗、网站公示、短信、邮件通知等方式。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >若您不同意修改后的隐私政策，您有权并应立即停止使用文通云教师端的服务。如果您继续使用文通云教师端的服务，则视为您接受文通云教师端对本政策相关条款所做的修改
          文通云教师端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明我方在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        &nbsp;
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 18.67px"
          >九、&nbsp;联系我们</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;如果您有任何个人信息的疑问、意见、建议或投诉举报，您可以通过电话（17708004966）或邮箱（ckwool@qq.com）随时与我们联系&nbsp;，我们将在15日内回复您的请求。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
          text-indent: 26.67px;
        "
      >
        <br />
        <span style="font-family: '等线'; font-size: 18.67px">十、更新说明</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >&nbsp;
          &nbsp;成都文通网络科技发展有限公司保留随时更新本声明的权利，当声明发生修改时，我们会通过通知的方式告知您变更后的声明。如您继续使用我们的服务，即视为您同意我们的变更后的隙私政策我们才会按照更新的声明收集、使用、存储您的个人信息。</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-left: 28px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        <span style="font-family: '等线'; font-size: 13.33px"
          >本声明自更新之日起生效</span
        ><br />
        <span style="font-family: '等线'; font-size: 13.33px"
          >最近的更新日期：2024&nbsp;年&nbsp;3月&nbsp;19&nbsp;日</span
        >
      </p>
      <p
        style="
          line-height: 1.5;
          margin-bottom: 0px;
          margin-top: 0px;
          text-align: justify;
        "
      >
        &nbsp;
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {
    // if(this.$route.query.type == 'student'){

    // }
    document.title = "隐私政策";
    document.oncontextmenu = function (e) {
      e.preventDefault();
    };
    document.onselectstart = function (e) {
      e.preventDefault();
    };
    //安卓
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
    document.ontouchend = function () {
      throw new Error("NO ERRPR:禁止长按弹出");
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.privacyPolicy {
  padding: 10px;
  .title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0;
    text-align: center;
  }
  tr {
    display: flex;
    width: 100%;
  }
  td {
    border: 1px solid #ddd;
    width: calc(20vw - 5px) !important;
    display: block;
    text-align: center;
    word-wrap: break-word;
    padding: 0 3px;
  }
}
</style>
